module.exports = __webpack_public_path__ + "img/channel_img4.71675dc5.png";